import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        // To use when you want one-off custom styling
        base: '',

        default: 'bg-primary text-primary-foreground hover:bg-primary/90 max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',
        primary: 'bg-primary text-primary-foreground hover:bg-primary/90 max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',
        secondary:
          'bg-secondary text-secondary-foreground hover:bg-secondary/80 max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',

        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90 max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',

        outline:
          'border border-input bg-background hover:bg-accent hover:text-accent-foreground max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',
        'outline-destructive':
          'border border-destructive bg-background hover:bg-destructive hover:text-destructive-foreground max-md:shadow-sm max-md:transition-all max-md:active:scale-[0.98]',

        ghost: 'hover:bg-accent hover:text-accent-foreground max-md:transition-all max-md:active:scale-[0.98]',
        'ghost-primary':
          'text-primary hover:bg-primary hover:text-primary-foreground max-md:transition-all max-md:active:scale-[0.98]',

        link: 'text-neutral-900 underline-offset-4 hover:underline dark:text-neutral-50 font-semibold',
      },
      size: {
        default: 'h-10 px-4 py-2 rounded-md max-md:h-11 max-md:px-5 max-md:py-2.5 max-md:rounded-xl',
        sm: 'h-9 px-3 rounded-md text-xs max-md:px-3.5 max-md:rounded-lg',
        lg: 'h-11 px-8 rounded-md text-base max-md:h-14 max-md:rounded-2xl max-md:px-10 max-md:font-bold',

        'icon-xs': 'h-8 w-8 rounded-lg',
        'icon-sm': 'h-9 w-9 rounded-lg',
        icon: 'h-10 w-10 rounded-md max-md:h-11 max-md:w-11 max-md:rounded-xl',
        'icon-lg': 'h-11 w-11 rounded-md max-md:h-14 max-md:w-14 max-md:rounded-2xl',
        'icon-xl': 'h-16 w-16 rounded-[20px]',
        'icon-2xl': 'h-20 w-20 rounded-[24px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
